module.exports = __webpack_public_path__ + "img/hospital.b40925bc.svg";